import Vue from "vue";
import "babel-polyfill";
import App from "./App";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
import Toasts from "~common/commonModule/passport/components/toast.js";
import store from "./store";
import {setCurDomain, setEntity} from "~common/assets/js/utils.js";
console.log(setCurDomain(),'==setCurDomain===', setEntity(), '===setEntity==')
let getEntity = setEntity()
let getCurDomain = setCurDomain()
window.wx = require('weixin-js-sdk')

// import VConsole from "vconsole/dist/vconsole.min.js"; //import vconsole
import {
  Input,
  Menu,
  Submenu,
  MenuItem,
  Select,
  Option,
  Button,
  MessageBox
} from "element-ui";
Vue.use(Input);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Toasts);
Vue.config.productionTip = false;
Vue.prototype.$confirm = MessageBox;
Vue.prototype.$domain = getCurDomain;
Vue.prototype.$entity = getEntity;

import {
  Cell,
  CellGroup,
  Field,
  ActionSheet,
  Tab,
  Tabs,
  IndexBar,
  IndexAnchor,
  Icon,
  Form,
  Toast,
  Search,
  Popup,
  Dialog
} from "vant";
import vantButton from "vant/lib/button";
import "vant/lib/button/style";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(ActionSheet);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Icon);
Vue.use(Search);
Vue.use(Search);
Vue.use(Form);
Vue.use(vantButton);

Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;

// 配置调试工具
const JY_ENV = process.env.JY_ENV;
if (JY_ENV != "production") {
  // let vConsole = new VConsole();
}
// 日志配置
import TalUdcLogJSSDK from "@udc/udc_log_jssdk";
var setLogInitConfig = {
  // 业务Id,这个由业务方申请，下发给业务方 必传
  biz_id: "tal_passport_center_log_collect",
  // 是否开启trace链路追踪功能 (即在所有ajax请求的header头中添加了字段traceid和rpcid), 默认开启
  traceId: false,
  // 是否开启自动上报pv页面渲染完成日志，默认开启
  loadMsg: true,
  // 当loadMsg为true即开启自动上报pv日志时，设置需要过滤掉自动上报pv日志的页面信息
  pvfilter_pageinfo: {
    // 页面路由采取的形式，是否为hash，如果是hash该值写hash，否则空，默认空
    routerType: "",
    // 不需要自动上报pv日志的页面路由，默认空数组,(数组中填写页面路由，vue填写对应的路由path，否则填写域名后的路由，不带参数(即window.location.pathname(去掉后面的路由参数)))
    pageRouter: []
  },
  // 是否开启自动上报资源文件报错sys系统日志，默认开启
  resource: true,
  // vue的配置信息
  vueInfo: {
    // vuejs框架的Vue变量，目的为了非npm包Vue引入时能监控到vue组件中js错误异常情况和能够获取到Vue的变量，该值是vuejs框架的Vue对象值，如import Vue from 'vue'中的Vue，默认空
    vue: "",
    // 路由是否hash带#，如果是hash一定要传该值，否则会影响到referer地址的正确定，默认不为hash
    isHash: false,
    // vue的路由初始化配置，目的为了单页面路由跳转时获取到页面的referer，不传单页面路由跳转无法获取到referer，该值是初始化路由后的值，如const router = new Router({routes: routes})中的router，默认空
    vueRouter: ""
  },
  // 是否开启自动上报vue组件中js错误捕获sys系统日志，默认不开启（非vue组件中的js错误不起作用）
  vueException: true,
  // 是否开启自动上报非vue组件中Scriptjs错误捕获sys系统日志，默认不开启（vue组件中的js错误不起作用）
  scriptException: true,
  // 过滤某些文件中js错误异常文件不自动上传sys系统日志的文件url，scriptException字段为true时生效（包括vue组件和非vue的Script错误），默认空
  sysfilter_scripterrdata: [],
  // 全局个性化自定义公共参数，即每个业务id中的所有日志公共参数，即每个biz_id下的所有日志公共参数，比如version，参数的形式可以是对象，也可以是&拼接的字符串如pageId=数据风向页面&id=123
  logcom_specialdata: "",
  // 全局个性化异步获取的数据传递，使用回调方法的形式，方法返回数据为对象或&拼接的字符串，注意返回的数据字段不可与logcom_specialdata对象中的字段重复，否则会覆盖
  logcom_asyncdata: function() {
    return {};
  },
  // pv页面渲染日志自定义特殊公共参数，参数的形式可以是对象，也可以是&拼接的字符串如pageId=数据风向页面&id=123
  pvcom_specialdata: "",
  // 是否开启自动上报ajax请求结果sys系统日志，默认开启
  ajaxRequest: true,
  // 过滤特殊ajax请求结果不自动上传sys系统日志
  sysfilter_ajaxdata: [],
  // 使用sdk的环境配置，分为测试(release)、沙箱测试(sandbox)、线上(production)三个环境，使用npm包安装时不传默认线上，使用cdn引入时根据外链地址会自动区分环境，建议统一手动配置该环境变量（备注：对接方在测试环境对接时，建议直接采取沙箱测试环境(sandbox)，无需绑定host）
  env: (JY_ENV != "production") ? 'sandbox' : 'production',
  entity: getEntity,
  // 每个路由页面的配置详情
  pageConfig: {
    // 是否开启页面路由发生变化时，自动上报pv页面渲染完成日志，默认开启，当开启自动上报pv日志loadMsg为true时，方可生效
    pageChange: true,
    //是否开启触发hashChange时，自动上报pv页面渲染完成日志，且routerType字段为hash，loadMsg和pageChange均为true时，才会触发hashChange事件（hash路由，即URL字符串中带#），默认不开启
    hashChange: false,
    // 页面路由采取的形式，是否为hash，如果是hash该值写hash，否则空，默认空
    routerType: "",
    // 每个路由页面相关的信息, 默认空数组
    pageInfo: []
    // pageInfo: [{
    //   // 页面路由，vue填写对应的路由path，否则填写域名后的路由，不带参数(即window.location.pathname(去掉后面的路由参数))
    //   pageRouter: 'page1',
    //   // 该页面自定义的公共参数，即该页面所有类型日志需要的自定义公共参数，参数的形式可以是对象，也可以是&拼接的字符串如pageId=数据风向页面&id=123
    //   pageParams: {
    //     pageId: '数据风向页面'
    //   },
    //   // 该页面异步获取的数据传递，使用回调方法的形式，方法返回数据为对象或&拼接的字符串，注意返回的数据字段不可与pageParams对象中的字段重复，否则会覆盖
    //   pageAsyncCallbackData: function () {
    //     return {}
    //   }
    // }]
  }
};

// npm安装引入使用Vue注入方式上报（在main.js 或者 App.vue组件等项目全局文件中初始化）
Vue.use(TalUdcLogJSSDK, setLogInitConfig);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./module/passport/src/main.js